import React from 'react';
import { Shield, Lock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const BADGE_PERFIL = {
  admin:    'bg-violet-900/40 text-violet-400 border border-violet-800/30',
  contador: 'bg-blue-900/40 text-blue-400 border border-blue-800/30',
  cliente:  'bg-slate-700/60 text-slate-400 border border-slate-600/30',
};

export default function PerfilPage() {
  const { usuario } = useAuth();

  return (
    <div className="max-w-xl space-y-5">
      {/* Card de identidade */}
      <div className="card">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary-600 to-primary-800 flex items-center justify-center text-2xl font-bold text-white shadow-lg shadow-primary-900/50 flex-shrink-0">
            {usuario?.nome?.charAt(0).toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-lg font-bold text-slate-100 truncate">{usuario?.nome}</p>
            <p className="text-sm text-slate-500 truncate">{usuario?.email}</p>
            <span className={"inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full capitalize mt-1 " + (BADGE_PERFIL[usuario?.perfil] || '')}>
              <Shield size={10} />
              {usuario?.perfil}
            </span>
          </div>
        </div>
      </div>

      {/* Aviso senha */}
      <div className="card border border-slate-700/50">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0 mt-0.5">
            <Lock size={15} className="text-slate-400" />
          </div>
          <div>
            <h2 className="text-sm font-semibold text-slate-200 mb-1">Senha de acesso</h2>
            <p className="text-xs text-slate-500 leading-relaxed">
              A senha é gerenciada pelo <strong className="text-slate-300">CRM Kaírós</strong>.<br />
              Para alterar, solicite ao administrador do sistema.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
